import React, {useState} from "react";
import PropTypes from "prop-types";

import ModalElementDisabledHistory from "./ModalElementDisabledHistory.js";
import ModalDisableElementForm from "./ModalDisableElementForm.js";

const ModalDisableElement = ({
  visible,
  setVisible,
  target,
  disabled,
  requireNote,
  submitNote,
  cancel,
  goBack,
  showHistory = false
}) => {
  const [historyVisible, setHistoryVisible] = useState(false);

  if (historyVisible)
    return (
      <ModalElementDisabledHistory
        visible={historyVisible}
        setVisible={setVisible}
        goBack={() => setHistoryVisible(false)}
        target={target}
      />
    );

  return (
    <ModalDisableElementForm
      visible={visible}
      setVisible={setVisible}
      target={target}
      disabled={disabled}
      requireNote={requireNote}
      submitNote={submitNote}
      cancel={cancel}
      goBack={goBack}
      showHistory={showHistory}
      onOpenHistory={() => setHistoryVisible(true)}
    />
  );
};

ModalDisableElement.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  submitNote: PropTypes.func.isRequired,
  goBack: PropTypes.func,
  cancel: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  target: PropTypes.objectOf(PropTypes.any).isRequired,
  requireNote: PropTypes.bool,
  showHistory: PropTypes.bool
};

export default ModalDisableElement;
